(function () {
	'use strict';

	angular
		.module('app')
		.directive('passwordValidator', emailValidator);

	emailValidator.$inject = ['$window'];

	function emailValidator($window) {
		// Usage:
		//     <passwordValidator></passwordValidator>
		// Creates:
		// 
		var directive = {
			restrict: 'A',
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, $ctrl) {
			$ctrl.$parsers.unshift(function (value) {
				let isValid = true;
				let passwordRegexPattern = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s/;
				let passwordLength = 6;

				if (value) {
					isValid = (value.length >= passwordLength && passwordRegexPattern.test(value));
					$ctrl.$setValidity('invalidPassword', isValid);

					return isValid ? value : "";
				} else {
					return isValid;
				}
			});
		}
	}
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/validators/_passwordValidator.js
// module id = 21
// module chunks = 0